import { c as _c } from "react/compiler-runtime";
import React from "react";
import { useWidgetDispatch, useWidgetSelector } from "../../../store/store";
import { NumericFormat } from "react-number-format";
import { State } from "../../../store/state";
import { setGlobalOperationsEnabled, setGlobalOperationsPercentage, setOperationsPercentageModeByCauseArea } from "../../../store/actions";
import { CustomCheckBox } from "../DonorPane/CustomCheckBox";
import { OperationsConfig } from "../../../types/WidgetProps";
import { splitOperationsLabelTemplate } from "../../../utils/operationsLabel";
import styles from "../AmountPane.module.scss";
import forms from "../Forms.module.scss";
interface GlobalCutToggleProps {
  operationsConfig?: OperationsConfig;
}
export const GlobalCutToggle: React.FC<GlobalCutToggleProps> = t0 => {
  const $ = _c(36);
  const {
    operationsConfig
  } = t0;
  const dispatch = useWidgetDispatch();
  const {
    globalOperationsEnabled: t1,
    globalOperationsPercentage: t2,
    operationsConfig: stateConfig
  } = useWidgetSelector(_temp);
  const globalOperationsEnabled = t1 === undefined ? false : t1;
  const globalOperationsPercentage = t2 === undefined ? 5 : t2;
  const causeAreas = useWidgetSelector(_temp2) ?? [];
  const t3 = operationsConfig?.operations_label_template;
  let t4;
  if ($[0] !== t3) {
    t4 = splitOperationsLabelTemplate(t3);
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const {
    prefix: operationsLabelPrefix,
    suffix: operationsLabelSuffix
  } = t4;
  let t5;
  if ($[2] !== causeAreas || $[3] !== dispatch || $[4] !== stateConfig?.excludedCauseAreaIds || $[5] !== stateConfig?.operationsCauseAreaId) {
    t5 = checked => {
      dispatch(setGlobalOperationsEnabled(checked));
      causeAreas.filter(area => area.id !== stateConfig?.operationsCauseAreaId && !stateConfig?.excludedCauseAreaIds?.includes(area.id)).forEach(area_0 => dispatch(setOperationsPercentageModeByCauseArea(area_0.id, checked)));
    };
    $[2] = causeAreas;
    $[3] = dispatch;
    $[4] = stateConfig?.excludedCauseAreaIds;
    $[5] = stateConfig?.operationsCauseAreaId;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const handleGlobalCutToggle = t5;
  let t6;
  if ($[7] !== dispatch) {
    t6 = (values, sourceInfo) => {
      if (sourceInfo.source !== "event") {
        return;
      }
      const v = values.floatValue === undefined ? 0 : values.floatValue;
      const limitedPercentage = Math.min(Math.max(v, 0), 100);
      dispatch(setGlobalOperationsPercentage(limitedPercentage));
    };
    $[7] = dispatch;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const handlePercentageChange = t6;
  let t7;
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      marginTop: "20px",
      marginBottom: "20px",
      padding: "15px",
      border: "1px solid var(--primary)",
      borderRadius: "8px"
    };
    t8 = {
      display: "flex",
      alignItems: "center",
      gap: "10px"
    };
    $[9] = t7;
    $[10] = t8;
  } else {
    t7 = $[9];
    t8 = $[10];
  }
  let t9;
  if ($[11] !== handleGlobalCutToggle) {
    t9 = e => handleGlobalCutToggle(e.target.checked);
    $[11] = handleGlobalCutToggle;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== globalOperationsEnabled || $[14] !== t9) {
    t10 = <input className={forms.hiddenCheckBox} type="checkbox" checked={globalOperationsEnabled} onChange={t9} data-cy="global-cut-checkbox" />;
    $[13] = globalOperationsEnabled;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== globalOperationsEnabled) {
    t11 = <CustomCheckBox checked={globalOperationsEnabled} label="" />;
    $[16] = globalOperationsEnabled;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t10 || $[19] !== t11) {
    t12 = <div className={forms.checkBoxWrapper}>{t10}{t11}</div>;
    $[18] = t10;
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== operationsLabelPrefix) {
    t13 = operationsLabelPrefix && <span>{operationsLabelPrefix}</span>;
    $[21] = operationsLabelPrefix;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  const t14 = !globalOperationsEnabled;
  let t15;
  if ($[23] !== globalOperationsPercentage || $[24] !== handlePercentageChange || $[25] !== t14) {
    t15 = <span><NumericFormat name="global-percentage-cut" allowNegative={false} decimalScale={1} max={100} type="tel" placeholder="5" value={globalOperationsPercentage} autoComplete="off" data-cy="global-percentage-cut-input" onValueChange={handlePercentageChange} disabled={t14} /></span>;
    $[23] = globalOperationsPercentage;
    $[24] = handlePercentageChange;
    $[25] = t14;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== operationsLabelSuffix) {
    t16 = operationsLabelSuffix && <span>{operationsLabelSuffix}</span>;
    $[27] = operationsLabelSuffix;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t13 || $[30] !== t15 || $[31] !== t16) {
    t17 = <div className={styles.operationsPercentageInputWrapper}>{t13}{t15}{t16}</div>;
    $[29] = t13;
    $[30] = t15;
    $[31] = t16;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== t12 || $[34] !== t17) {
    t18 = <div style={t7}><div style={t8}>{t12}{t17}</div></div>;
    $[33] = t12;
    $[34] = t17;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  return t18;
};
function _temp(state) {
  return state.donation;
}
function _temp2(state_0) {
  return state_0.layout.causeAreas;
}